import React from 'react';
import { DesktopContainer } from './style';

export default ({ children }) => {
  return <DesktopContainer>{children}</DesktopContainer>;
};
